export default "__VITE_ASSET__BK8ooP6k__"